module.exports = __webpack_public_path__ + "img/ESG_02_4.0734d0f3.jpg";